import Cookies from "js-cookie";
import base64 from "base-64";
import { wfetch } from "../../../utils/fetch";

const leadCookieName = "mgnl_le";
const iubCookieName = "_iub_cs-841284"; // iubenda cookie consent

export const setLeadCookie = (formElements) => {
    const iubCookie = Cookies.get(iubCookieName);

    if (!iubCookie) return;

    const iubConsentSettings = JSON.parse(decodeURIComponent(iubCookie));

    if (
        !iubConsentSettings ||
        !iubConsentSettings.purposes ||
        (!iubConsentSettings.purposes[2] && !iubConsentSettings.purposes[3])
    ) {
        Cookies.remove(leadCookieName);
        return;
    }

    for (const element of formElements) {
        const elementName = element.name;
        const elementValue = element.value;

        if (elementName && elementName === "Email" && elementValue) {
            Cookies.set(leadCookieName, base64.encode(elementValue));
            break;
        }
    }
};

const getLeadCookie = () => {
    const leadCookieValue = Cookies.get(leadCookieName);

    return leadCookieValue ? base64.decode(leadCookieValue) : null;
};

const getFormInputNames = (formElements) => {
    const fields = [];

    for (const fieldName of Object.keys(formElements)) {
        const firstLetter = fieldName.charAt(0);

        if (firstLetter.toUpperCase() === firstLetter && !Number.isInteger(parseInt(fieldName, 10)))
            fields.push(fieldName);
    }

    return fields;
};

const fillForm = (formElements, data) => {
    for (const [index, value] of Object.entries(data)) {
        for (const element of formElements) {
            const elementName = element.name;

            if (index.toLowerCase() !== elementName.toLowerCase()) continue;

            element.value = value;
            ["input", "change"].forEach((event) =>
                element.dispatchEvent(new Event(event, { bubbles: true }))
            );
        }
    }
};

export default function(formWrapper, formElements) {
    const requestedFields = getFormInputNames(formElements);
    const leadCookie = getLeadCookie();
    const baseUrl = formWrapper.dataset.restUrl;

    if (!baseUrl || requestedFields.length === 0 || !leadCookie) return;

    wfetch(`${baseUrl}?filterValues=${leadCookie}&fields=${requestedFields.join(",")}`)
        .then((result) => {
            if (result.data.success && result.data.result[0]) fillForm(formElements, result.data.result[0]);
        })
        .catch((err) => {});
}
